(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var panel = drawer.querySelector('.cart-drawer__panel');
    var alertEl = drawer.querySelector('[data-cart-alert]');
    var statusEl = drawer.querySelector('[data-cart-status]');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var SECTION = 'cart-drawer';
    var lastFocus = null;

    function focusables() {
      return Array.prototype.slice
        .call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.offsetParent !== null; });
    }
    function announce(msg) { if (statusEl) statusEl.textContent = msg; }
    function showError(msg) {
      if (!alertEl) return;
      alertEl.textContent = msg;
      alertEl.hidden = false;
      announce(msg);
    }
    function clearError() {
      if (!alertEl) return;
      alertEl.hidden = true;
      alertEl.textContent = '';
    }

    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var closeBtn = drawer.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 450);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function paintBadge() {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var b = document.querySelector('[data-cart-count]');
          if (!b) return;
          b.textContent = c.item_count;
          if (c.item_count > 0) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden', ''); }
        })
        .catch(function () {});
    }

    function rerender(sections) {
      if (sections && sections[SECTION]) {
        var doc = new DOMParser().parseFromString(sections[SECTION], 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-contents]');
        var live = drawer.querySelector('[data-cart-drawer-contents]');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
      }
      paintBadge();
    }

    function changeQty(line, qty) {
      clearError();
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty, sections: SECTION, sections_url: window.location.pathname }),
      })
        .then(function (r) { return r.json().then(function (c) { return { ok: r.ok, body: c }; }); })
        .then(function (res) {
          if (!res.ok) {
            // Stock insuffisant / ligne indisponible : la quantité affichée reste correcte (DOM non modifié)
            showError(res.body.description || res.body.message || 'Quantité indisponible.');
            return;
          }
          rerender(res.body.sections);
          announce('Panier mis à jour.');
        })
        .catch(function () { showError('Une erreur est survenue. Réessayez.'); });
    }

    // Clics : ouverture, fermeture, +/-, retrait
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); clearError(); open(); paintBadge(); return; }
      if (e.target.closest('[data-cart-close]')) { close(); return; }
      var chg = e.target.closest('[data-line-change]');
      if (chg) {
        var li = chg.closest('[data-line]');
        var input = li.querySelector('[data-line-qty]');
        var q = (parseInt(input.value, 10) || 1) + parseInt(chg.dataset.lineChange, 10);
        if (q < 0) q = 0;
        changeQty(li.dataset.line, q);
        return;
      }
      var rm = e.target.closest('[data-line-remove]');
      if (rm) {
        var li2 = rm.closest('[data-line]');
        changeQty(li2.dataset.line, 0);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      // Piège le focus dans le panneau (composant modal)
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Intercepte tous les formulaires d'ajout au panier (PDP, cartes, etc.)
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action$="/cart/add"], form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      clearError();
      var fd = new FormData(form);
      fd.append('sections', SECTION);
      fd.append('sections_url', window.location.pathname);
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) {
            open();
            showError(res.body.description || res.body.message || "Impossible d'ajouter au panier.");
            return;
          }
          rerender(res.body.sections);
          open();
          announce('Article ajouté au panier.');
        })
        .catch(function () { open(); showError("Impossible d'ajouter au panier. Réessayez."); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // Révélation au défilement — global (le footer est présent sur toutes les pages).
  (function () {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16 }
    );
    els.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-site-header]');
    var drawer = document.querySelector('[data-drawer]');

    // État scrollé (uniquement utile en mode overlay, sans danger ailleurs)
    if (header) {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 40);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Drawer mobile
    if (drawer) {
      var openBtn = document.querySelector('[data-drawer-open]');
      var panel = drawer.querySelector('.site-drawer__panel');
      var lastFocus = null;

      var focusables = function () {
        if (!panel) return [];
        return Array.prototype.slice
          .call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
          .filter(function (el) { return el.offsetParent !== null; });
      };
      var open = function () {
        lastFocus = document.activeElement;
        drawer.hidden = false;
        // force reflow pour que la transition s'applique
        void drawer.offsetWidth;
        drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
        var closeBtn = drawer.querySelector('[data-drawer-close]');
        if (closeBtn) closeBtn.focus();
      };
      var close = function () {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        window.setTimeout(function () {
          if (!drawer.classList.contains('is-open')) drawer.hidden = true;
        }, 500);
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      };
      if (openBtn) openBtn.addEventListener('click', open);
      drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (!drawer.classList.contains('is-open')) return;
        if (e.key === 'Escape') { close(); return; }
        // Piège le focus dans le panneau (composant modal)
        if (e.key === 'Tab') {
          var f = focusables();
          if (!f.length) return;
          var first = f[0];
          var last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var acc = document.querySelector('[data-accordion]');
    if (!acc) return;

    var setOpen = function (item, open) {
      var body = item.querySelector('.acc-body');
      var head = item.querySelector('.acc-head');
      item.classList.toggle('is-open', open);
      if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (body) body.style.maxHeight = open ? body.scrollHeight + 'px' : null;
    };

    acc.addEventListener('click', function (e) {
      var head = e.target.closest('.acc-head');
      if (!head) return;
      var item = head.parentElement;
      var willOpen = !item.classList.contains('is-open');
      acc.querySelectorAll('.acc-item').forEach(function (it) { setOpen(it, false); });
      if (willOpen) setOpen(item, true);
    });

    // Ouvre le premier au chargement
    var first = acc.querySelector('.acc-item.is-open');
    if (first) setOpen(first, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-tabs]').forEach(function (group) {
      var setOpen = function (item, open) {
        var body = item.querySelector('.tab-body');
        var head = item.querySelector('.tab-head');
        item.classList.toggle('is-open', open);
        if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (body) body.style.maxHeight = open ? body.scrollHeight + 'px' : null;
      };

      group.addEventListener('click', function (e) {
        var head = e.target.closest('.tab-head');
        if (!head) return;
        var item = head.parentElement;
        var willOpen = !item.classList.contains('is-open');
        group.querySelectorAll('.tab-item').forEach(function (it) { setOpen(it, false); });
        if (willOpen) setOpen(item, true);
      });

      // Ouvre le premier onglet au chargement.
      var first = group.querySelector('.tab-item');
      if (first) setOpen(first, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-pdp]');
    if (!root) return;

    // Galerie : changement d'image principale
    var stage = root.querySelector('[data-stage]');
    var thumbs = root.querySelector('[data-thumbs]');
    if (stage && thumbs) {
      thumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-thumb]');
        if (!btn) return;
        thumbs.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        stage.style.opacity = '0';
        window.setTimeout(function () {
          stage.src = btn.dataset.src;
          stage.style.opacity = '1';
        }, 180);
      });
    }

    // Sélecteur de variante : met à jour prix, prix barré, dispo et bouton.
    // L'ajout au panier reste piloté par `name="id"` du select (soumission native).
    var select = root.querySelector('[data-variant-select]');
    if (select) {
      var variants = [];
      var dataEl = root.querySelector('[data-pdp-variants]');
      if (dataEl) {
        try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      }
      var priceEl = root.querySelector('[data-price]');
      var priceWasEl = root.querySelector('[data-price-was]');
      var addBtn = root.querySelector('[data-add]');
      var addLabel = root.querySelector('[data-add-label]');
      var buynowBtn = root.querySelector('[data-buynow]');

      var updateVariant = function () {
        var id = parseInt(select.value, 10);
        var v = null;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === id) { v = variants[i]; break; }
        }
        if (!v) return;
        if (priceEl) priceEl.textContent = v.price;
        if (priceWasEl) {
          if (v.compare_at) {
            priceWasEl.textContent = v.compare_at;
            priceWasEl.hidden = false;
          } else {
            priceWasEl.textContent = '';
            priceWasEl.hidden = true;
          }
        }
        if (addBtn) addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
        if (buynowBtn) buynowBtn.disabled = !v.available;
        // Lien partageable : reflète la variante dans l'URL sans recharger.
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          window.history.replaceState({}, '', url);
        }
      };
      select.addEventListener('change', updateVariant);
    }

    // Quantité (l'ajout au panier est géré globalement par le mini-panier)
    var qty = root.querySelector('[data-qty]');
    if (qty) {
      var step = function (delta) {
        var v = parseInt(qty.value, 10) || 1;
        v = Math.min(99, Math.max(1, v + delta));
        qty.value = v;
      };
      var minus = root.querySelector('[data-qty-minus]');
      var plus = root.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () { step(-1); });
      if (plus) plus.addEventListener('click', function () { step(1); });
    }

    // « Acheter maintenant » : ajoute au panier puis redirige vers le checkout
    var buynow = root.querySelector('[data-buynow]');
    if (buynow) {
      var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      buynow.addEventListener('click', function () {
        if (buynow.hasAttribute('disabled') || buynow.classList.contains('is-loading')) return;
        var idEl = root.querySelector('[data-pdp-form] [name="id"]');
        var id = idEl ? idEl.value : null;
        if (!id) return;
        var quantity = qty ? (parseInt(qty.value, 10) || 1) : 1;
        buynow.classList.add('is-loading');
        fetch(routeRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(id), quantity: quantity })
        })
          .then(function (r) {
            if (!r.ok) { throw new Error('add failed'); }
            window.location.href = routeRoot + 'checkout';
          })
          .catch(function () {
            buynow.classList.remove('is-loading');
          });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
